export interface ICategory {
    id: string;
    name: string;
    slug: string;
    background_color: string;
    can_edit_sub_categories: boolean;
    sub_categories: string[];
}

export const mapCategoryFromApi = (apiCategory: any): ICategory => ({
    ...apiCategory,
    sub_categories: Object.keys(apiCategory.sub_categories),
})

export const mapCategoriesFromApi = (apiCategories: any): ICategory[] => {
    return apiCategories.map(c => mapCategoryFromApi(c))
}


// WEBPACK FOOTER //
// ./src/type/category.ts